import CircularProgress from '@mui/material/CircularProgress';

function Loader() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <CircularProgress
        sx={{
          color: '#2f999d',
        }}
      />
      <p
        style={{
          fontSize: '2.3vh',
          paddingTop: '2%',
          marginLeft: '2%',
        }}
      >
        Loading...
      </p>
    </div>
  );
}

export default Loader;
